import { sentryCreateBrowserRouter } from "../../lib/sentry/sentry-utils";
import App from "./App";
import { Login } from "./pages/login/login.page";
import { PatientsPage } from "./pages/Patients/patients.page";
import { JobsPage } from "./pages/Jobs/jobs.page";
import { ProfilePage } from "./pages/Profile/profile.page";
import { NotFoundPage } from "./pages/404.page";
import { JobPage } from "./pages/Jobs/job.page";
import { PatientPage } from "./pages/Patients/patient.page";
import { ChatsPage } from "./pages/Chat/chats.page";
import { ChatPage } from "./pages/Chat/chat.page";
import { Navigate } from "react-router-dom";
import { ScanPage } from "./pages/Scan/scan.page";
import { ActionsPage } from "./pages/Actions/actions.page";

export const router = sentryCreateBrowserRouter([
	{
		path: "/",
		element: <App />,
		children: [
			{
				path: "/login",
				element: <Login />,
			},
			{
				path: "/",
				element: <Navigate to="/actions" />,
			},
			{
				path: "/patients",
				element: <PatientsPage />,
			},
			{
				path: "/jobs",
				element: <JobsPage />,
			},
			{
				path: "/profile",
				element: <ProfilePage />,
			},
			{
				path: "/job/:id",
				element: <JobPage />,
			},
			{
				path: "/job/:id/:tab",
				element: <JobPage />,
			},
			{
				path: "/patient/:id",
				element: <PatientPage />,
			},
			{
				path: "/chat",
				element: <ChatsPage />,
			},
			{
				path: "/chat/:clientId",
				element: <ChatPage />,
			},
			{
				path: "/scan/:jobId/:jobDocumentId",
				element: <ScanPage />,
			},
			{
				path: "/scan",
				element: <ScanPage />,
			},
			{
				path: "/actions",
				element: <ActionsPage />,
			},
			{
				path: "*",
				element: <NotFoundPage />,
			},
		],
	},
]);
